import styled from "styled-components"
import { CarouselProvider, ButtonBack, ButtonNext, Slider, Slide } from "pure-react-carousel"

import { maxWidth, minWidth } from "utils"

export { Slide } from "pure-react-carousel"

export const SliderRelative = styled(Slider)`
  position: relative;
  ${({ itemType }) => itemType !== "ContentfulTextBlurb" && "margin: 0 7.5rem"};
  ${maxWidth.mobile`
   ${({ itemType }) => itemType !== "ContentfulTextBlurb" && " margin: 0 1rem"};
  `}
`
export const SlideElement = styled(Slide)`
  padding: ${({ colMargin }) => `0 ${colMargin}`};
  ${({ itemType }) =>
    itemType === "ContentfulTextBlurb" &&
    `
      div {
        section {
          padding-left: 3rem;
          padding-right: 3rem;
        }
      }
  `};
  ${({ isTestimonialWithoutImages }) =>
    isTestimonialWithoutImages &&
    `
      div {
        height: 100%;
      }
  `};
  height: 100%;
`

export const GridGallerySection = styled.section`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "block")};
  background-color: ${({ itemType, theme }) =>
    itemType === "ContentfulTextBlurb" ? "ffffff" : theme.component.background};
  ${({ itemType }) => itemType === "ContentfulTextWithMedia" && "padding: 0 0 6rem 0"};
`

export const Carousel = styled(CarouselProvider)`
  position: relative;

  cursor: grab;

  :active {
    cursor: grabbing;
  }

  li.carousel__slide {
    padding-bottom: 0 !important;
    height: auto;
  }

  div.carousel__inner-slide {
    position: static;
  }
`

export const ItemsSlide = styled.div`
  position: relative;
`

const handleBorderColor = (currentSlide, theme, device, isTextBlurb, isRight) => {
  if (device === "mobile") {
    if (isTextBlurb) {
      if (isRight) {
        if (currentSlide) {
          return theme.component.ctaInverted
        }
        return theme.component.ctaSecondary
      }
      if (currentSlide) {
        return theme.component.ctaInverted
      }
      return theme.component.ctaSecondary
    }
    return "#222"
  }
  if (isRight) {
    if (currentSlide) {
      return theme.component.ctaSecondary
    }
    return theme.component.ctaInverted
  }
  if (currentSlide) {
    return theme.component.ctaInverted
  }
  return theme.component.ctaSecondary
}

export const ArrowLeft = styled(ButtonBack)`
  position: absolute;
  z-index: 10;
  top: 50%;
  left: calc(5% - 1rem);
  ${minWidth.tablet`
    left: calc(5% - 3rem);
  `}
  ${minWidth.desktop`
    left: calc(5% - 5rem);
  `}
  ${({ arrowsCondition, theme, slide, isTextBlurb, device }) =>
    arrowsCondition
      ? `
          transform: rotate(135deg);
          ::after {
            content: "";
            display: inline-block;
            border: solid ${handleBorderColor(slide, theme, device, isTextBlurb, false)};
            border-width: 0 0.2rem 0.2rem 0;
            padding: 0.6rem;
          }
        `
      : `transform: rotate(180deg);`};
`

export const ArrowRight = styled(ButtonNext)`
  position: absolute;
  z-index: 10;
  top: 50%;
  right: calc(5% - 1rem);
  ${minWidth.tablet`
    right: calc(5% - 3rem);
  `}
  ${minWidth.desktop`
    right: calc(5% - 5rem);
  `}
  ${({ arrowsCondition, theme, slide, isTextBlurb, device }) =>
    arrowsCondition &&
    `
      transform: rotate(-45deg);
      ::after {
        content: "";
        display: inline-block;
        border: solid ${handleBorderColor(slide, theme, device, isTextBlurb, true)};
        border-width: 0 0.2rem 0.2rem 0;
        padding: 0.6rem;
      }
  `};
`
